<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
    >
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title">
            kodenames
          </v-list-tile-title>
        </v-list-tile>
        
        <v-divider></v-divider>
        
        <v-list-tile>
          <v-list-tile-content>
            <v-text-field v-model="seed" solo label="Word Sequence" hint="Word Sequence" persistent-hint  @click:append="randomSeed" prepend-icon="vpn_key" append-icon="refresh" mask="#####" pattern="[0-9]*"></v-text-field>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-divider></v-divider>
        
        <v-list-tile>
          <v-list-tile-content>
            <v-btn :dark="master" @click="master = !master" block>
              <v-icon left v-if="master">visibility</v-icon>
              <v-icon left v-else>visibility_off</v-icon>
              Spymaster
            </v-btn>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-list-tile>
          <v-list-tile-content>
            <v-select
              label="Word List"
              :items="wordbankOptions"
              v-model="wordbank"
            ></v-select>          
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app fixed>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      {{ seed }}
      <v-spacer></v-spacer>
      <span class="title red--text text--lighten-2">{{ red }}</span>
      <v-spacer></v-spacer>
      <span class="title blue--text text--lighten-2">{{ blue }}</span>
      <v-spacer></v-spacer>
      
      <v-btn @click="prevGame()" icon :disabled="gameno == 1"><v-icon>chevron_left</v-icon></v-btn>
      {{ gameno}}
      <v-btn @click="nextGame()" icon :disabled="gameno == 16"><v-icon>chevron_right</v-icon></v-btn>
    </v-toolbar>
    <v-content app>
      <v-container fluid fill-height class="pa-0" ref="container">
        <v-layout justify-space-between row fill-height>
          <v-flex v-for="(r, i) in cardRows" :key="r+'-'+i">
            <v-layout column fill-height>
<!--               <v-flex v-for="(card, j) in r" :key="card.word+'-'+j">{{ i }},{{ j }}</v-flex> -->
              <kn-card v-for="(card, j) in r" :key="card.word+'-'+j" 
                       :word="card.word" 
                       :type="card.type" 
                       :reveal="card.reveal" @reveal="reveal"
                       :master="master"></kn-card>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import KnCard from './components/knCard.vue'
  import wordlib from './words'
  import shuffleSeed from 'knuth-shuffle-seeded'
  export default {
    name: 'App',
    components: {
      'kn-card': KnCard
    },
    data: () => ({
      drawer: null,
      seed: 0,
      gameno: 1,
      master: false,
      cards: [],
      useMinHeight: false,
      wordbank: 'default',
      wordbankOptions: [
        { value: 'default',   text: 'Default Word List' },
        { value: 'movies',    text: 'Movies' },
        { value: 'nouns',     text: 'Nouns' },
      ]
    }),
    computed: {
      words() {
        const NUM_CARDS = 25;
        let words = wordlib[this.wordbank].slice(0);
        let deck = shuffleSeed(words, parseInt(this.seed));
        return deck.slice((this.gameno - 1) * NUM_CARDS, this.gameno * NUM_CARDS);
      },
      cardRows() {
        return [
          this.cards.slice(0,5),
          this.cards.slice(5,10),
          this.cards.slice(10,15),
          this.cards.slice(15,20),
          this.cards.slice(20)
        ];
      },
      red() {
        return this.cards.filter(c => c.type === 'red' && !c.reveal).length;
      },
      blue() {
        return this.cards.filter(c => c.type === 'blue' && !c.reveal).length;
      }
      
    },
    methods: {
      randomSeed() {
        this.seed = Math.floor(Math.random() * 99999);
      },
      nextGame() {
        let gameno = this.gameno + 1;
        this.gameno = Math.min(16, gameno);
      },
      prevGame() {
        let gameno = this.gameno - 1;
        this.gameno = Math.max(gameno, 1);
      },
      generateCards() {
        const words = this.words;
        let cards = [];
        
        // red words
        for (let w of words.slice(0, 8)) cards.push({word: w, type: 'red', reveal: false});
        // blue words
        for (let w of words.slice(8, 16)) cards.push({word: w, type: 'blue', reveal: false});
        // start team depends if game # is even/odd
        cards.push({word: words[16], type: (this.gameno % 2 == 0)?'red':'blue', reveal: false});
        // bomb word
        cards.push({word: words[17], type: 'bomb', reveal: false});
        // yellow words remaining words
        for (let w of words.slice(18,25)) cards.push({word: w, type: 'yellow', reveal: false});
        
        this.cards = shuffleSeed(cards, parseInt(this.seed));
      },
      reveal(word) {
        let card = this.cards.find((c) => {
          return c.word === word
        });
        card.reveal = !card.reveal;
      }
    },
    watch: {
      seed() {
        this.gameno = 1;
      },
      words() {
        this.generateCards();
      }
    },
    mounted() {
      this.randomSeed();
      this.$nextTick(function() {
        let cells = document.getElementsByClassName('cell');
        if (cells[0].clientHeight === 0) {
          this.useMinHeight = true;
          let minHeight = (this.$refs.container.parentNode.clientHeight - 48) / 5;
          for (let c of cells) {
            c.style.minHeight = minHeight + 'px';
          }
        }
      })
    }
  }
</script>